import React, { useCallback, useState } from "react";
import { BankSelect } from "./BankSelect";
import { useImportBankSelect } from "./hooks";

const ConnectedBankSelect = ({ onClose }: { onClose: () => void }) => {
  const bankSelect = useImportBankSelect();
  return <BankSelect {...bankSelect} onClose={onClose} />;
};

/**
 * Opens the bank selection step as a modal instead of navigating to a full
 * page (which would show the app header). Render the returned `bankSelectModal`
 * inside the router tree and call `openBankSelect` from a trigger.
 *
 * The bank search only runs while the modal is open (the connected component is
 * mounted only then), and the routing lives in `useImportBankSelect`, which is
 * called inside the router tree.
 */
export const useBankSelectModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openBankSelect = useCallback(() => setIsOpen(true), []);
  const closeBankSelect = useCallback(() => setIsOpen(false), []);

  const bankSelectModal = isOpen ? (
    <ConnectedBankSelect onClose={closeBankSelect} />
  ) : null;

  return { isOpen, openBankSelect, closeBankSelect, bankSelectModal };
};
